// @flow

export const APP_NAME = `${process.env.REACT_APP_RETAILER_APP_APP_NAME || ''}`;

export const FEEDBACK_PRODUCT_NAME = `${
  process.env.REACT_APP_RETAILER_APP_FEEDBACK_PRODUCT_NAME || ''
}`;

export const PRODUCT_NAME = {
  BIDCO: 'BIDCO',
  BUYGRO: 'BUYGRO',
  DISTIMAN: 'DISTIMAN',
  GENIEE: 'GENIEE',
  DIGITALSAATHI: 'DIGITALSAATHI',
  STONESLANE: 'STONESLANE',
};

export const PRODUCT_NAME_ALIAS = {
  [PRODUCT_NAME.BIDCO]: 'SuperM',
  [PRODUCT_NAME.BUYGRO]: 'BuyGro',
  [PRODUCT_NAME.DISTIMAN]: 'Distiman',
  [PRODUCT_NAME.GENIEE]: 'Geniee',
  [PRODUCT_NAME.DIGITALSAATHI]: 'Agri Input Marketplace',
  [PRODUCT_NAME.STONESLANE]: 'Masdary',
};

export const APP_PAGES = {
  APP_DRAWER: 'APP_DRAWER',
  BANNER: 'BANNER',
  CART: 'CART',
  COMPANY_DASHBOARD: 'COMPANY_DASHBOARD',
  CONTACT_SUPPORT: 'CONTACT_SUPPORT',
  DASHBOARD: 'DASHBOARD',
  FEEDBACK: 'FEEDBACK',
  REWARDS: 'REWARDS',
  PRODUCTS: 'PRODUCTS',
  ORDER_DETAILS: 'ORDER_DETAILS',
  OUTLET_PROFILE: 'OUTLET_PROFILE',
  USER_PROFILE: 'USER_PROFILE',
};

export const APP_FEATURES = {
  OUTLET_PROFILE: 'OUTLET_PROFILE',
  PRODUCT_BRANDS: 'PRODUCT_BRANDS',
  PRODUCT_RETURNS: 'PRODUCT_RETURNS',
  PRODUCT_CATEGORIES: 'PRODUCT_CATEGORIES',
  REPORTS: 'REPORTS',
};

const OutletEnumStatus = {
  ACTIVE: 'ACTIVE',
  AVAILABLE: 'AVAILABLE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
};

export const RetailerStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
};

export const OutletStatus = OutletEnumStatus;
export const OUTLET_COMPANY_STATUS = OutletEnumStatus;

export const EnumGRNStatus = {
  DELIVERED: 'DELIVERED',
  NOT_DELIVERED: 'NOT_DELIVERED',
  PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
  PENDING: 'PENDING',
};

export const ENUM_LOYALTY_REDEMPTION_STATE = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
};

export const LedgerEntryState = {
  BLOCKED: 'BLOCKED',
  EARNED: 'EARNED',
  EXPIRED: 'EXPIRED',
  PARKED: 'PARKED',
  REDEEMED: 'REDEEMED',
  ROLLBACK: 'ROLLBACK',
  REVERSED: 'REVERSED',
};

export const Currency = {
  EURO: 'EURO',
  INR: 'INR',
  SAR: 'SAR',
  USD: 'USD',
  YER: 'YER',
};

export const RedemptionRequestSource = {
  MB_RETAILER: 'MB_RETAILER',
};

export const EnumSkuSearchType = {
  BRAND: 'BRAND',
  CATEGORY: 'CATEGORY',
  SKU: 'SKU',
  SUBBRAND: 'SUBBRAND',
  SUBCATEGORY: 'SUBCATEGORY',
  VARIANT: 'VARIANT',
};

export const FEEDBACK_MODULES = {
  GENERAL: {
    NAME: 'GENERAL',
    ROUTE_TYPE: 'general',
  },
  ORDER_PLACEMENT: {
    NAME: 'ORDER_PLACEMENT',
    ROUTE_TYPE: 'order-placement',
  },
};

export const OrderAgreementState = {
  YES: 'YES',
  NO: 'NO',
};

export const ORDER_SOURCE = {
  RETAILER: 'retailer',
  BIZOM: 'bizom',
};

export const BannerPages = {
  COLLATERAL: 'Collateral',
  SKU_LIST: 'Skulist',
};

export const BannerTypes = {
  BANNER: 'Banner',
  NONE: 'none',
};

export const POP_TYPES = {
  IMAGE: 'IMAGE',
  PDF: 'PDF',
  HYPERLINK: 'HYPERLINK',
  VIDEO: 'VIDEO',
};

export const INVOICE_PAYMENT_STATUS = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
};

export const TRANSACTION_STATUS = {
  INITIATED: 'INITIATED',
  CANCELLED: 'CANCELLED',
};

export const INVOICE_STATUS = {
  ALL: 'ALL',
  PENDING: 'PENDING',
};

export const UPI_RESPONSE_STATUS = {
  SUBMITTED: 'SUBMITTED',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  // phone Pe return failed instead of failure
  FAILED: 'FAILED',
};

export const PAYMENT_STATUS = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
};

export const SKU_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const CONTACT_ENTITY = {
  COMPANY: 'COMPANY',
  WAREHOUSE: 'WAREHOUSE',
  DISTRIBUTOR: 'DISTRIBUTOR',
  USER: 'USER',
  OUTLET: 'OUTLET',
};

export const NOTIFICATION_STATUS = {
  READ: 'READ',
  UNREAD: 'UNREAD',
};

export const NOTIFICATION_TYPE = {
  PROMOTIONAL: 'PROMOTIONAL',
  TRANSACTIONAL: 'TRANSACTIONAL',
};

export const QUANTITY_OPTIONS = {
  BOTH: 0,
  CASES: 1,
  UNITS: 2,
};

export const CAMERA_DIRECTION = {
  BACK: 'BACK',
  FRONT: 'FRONT',
};

export const ORDER_STAGE = {
  ACCEPTED: 'ACCEPTED',
  DELIVERY: 'DELIVERY',
  FULFILLMENT: 'FULFILLMENT',
  PLACED: 'PLACED',
  REJECT: 'REJECT',
};

export const SALESMAN_SALE_RETURN_STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  REQUESTED: 'REQUESTED',
};

export const DISTRIBUTOR_SALES_RETURN_STATUS = {
  APPROVED: 'APPROVED',
  CONFIRMED: 'CONFIRMED',
  PARTIALREPLACED: 'PARTIALREPLACED',
  REJECTED: 'REJECTED',
  REPLACED: 'REPLACED',
  RETURNED: 'RETURNED',
};

export const ENUM_PRODUCT_ENTITY_TYPE = {
  BRAND: 'BRAND',
  CATEGORY: 'CATEGORY',
};

export const ENUM_REWARD_TYPE = {
  CASHBACK: 'CASHBACK',
  LOYALTYPOINT: 'LOYALTYPOINT',
};

export const ENUM_PAYMENT_GATEWAY = {
  NGENIUS: 'NGENIUS',
  NONE: 'NONE',
  OPENBANK: 'OPENBANK',
};

export const ENUM_RETAILER_LOG_ACTION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  OPEN: 'OPEN',
};

export const ENUM_COLLECTION_SOURCE = {
  RETAILER: 'retailer',
  SALESMAN: 'salesman',
};

export const ENUM_COLLECTION_STATUS = {
  ALL: 'ALL',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  PENDING: 'PENDING',
};

export const ENUM_COLLECTION_TYPE = {
  CASH: 'cash',
  ONLINE: 'online',
  UPI: 'upi',
  CHECK: 'check',
  CASHBACK: 'cashback',
};

export const COLLECTION_STATUS = {
  ALL: 'All',
  SUCCESS: 'Success',
  FAILURE: 'Failure',
  PENDING: 'Pending',
};

export const ENUM_ACTIVITY_TYPE = {
  SKU: 'SKU',
};

export const PRODUCT_CARD_SCOPE = {
  PRODUCT_LIST: 'PRODUCT_LIST',
  FAVOURITE_PRODUCTS: 'FAVOURITE_PRODUCTS',
  RECENT_ORDERED_PRODUCTS: 'RECENT_ORDERED_PRODUCTS',
};

export const COMMNUNICATION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const REQUEST_HEADERS = {
  AUTHORIZATION: 'authorization',
  X_RET_KEY: 'x-ret-key',
};

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'rToken',
  REFRESHED_AT: 'rAt',
};

export const UPDATE_TOKEN_TYPE = {
  GRANT: 'GRANT',
};

export const ANALYTICS_SCOPE = {
  HOME_BANNER: 'HOME_BANNER',
  HOME_BRANDS: 'HOME_BRANDS',
  HOME_COMPANIES: 'HOME_COMPANIES',
  HOME_CATEGORIES: 'HOME_CATEGORIES',
  HOME_LAST_ORDER: 'HOME_LAST_ORDER',
  HOME_FAVOURITE_PRODUCTS: 'HOME_FAVOURITE_PRODUCTS',
  HOME_RECENT_PURCHASED_PRODUCTS: 'HOME_RECENT_PURCHASED_PRODUCTS',
  PRODUCT_LIST: 'PRODUCT_LIST',
  CART: 'CART',
  TOP_BAR: 'TOP_BAR',
  APP_DRAWER: 'APP_DRAWER',
  SEARCH: 'SEARCH',
};

export const ANALYTICS_INPUT_TYPE = {
  TEXT: 'TEXT',
};

export const ANALYTICS_ITEM_TYPES = {
  PRODUCT: 'PRODUCT',
  BANNER: 'BANNER',
  PRODUCT_BRAND: 'PRODUCT_BRAND',
  PRODUCT_CATEGORY: 'PRODUCT_CATEGORY',
  ORDER: 'ORDER',
  LINK: 'LINK',
};

export const ANALYTICS_PAGE_LINKS = {
  SEARCH_ICON: 'SEARCH_ICON',
  NOTIFICATION_BELL_ICON: 'NOTIFICATION_BELL_ICON',
  CART_ICON: 'CART_ICON',
  HAMBURGER_ICON: 'HAMBURGER_ICON',
  PROFILE_DRAWER_MENU: 'PROFILE_DRAWER_MENU',
  HOME_DRAWER_MENU: 'HOME_DRAWER_MENU',
  ORDERS_DRAWER_MENU: 'ORDER_DRAWER_MENU',
  PAYMENTS_DRAWER_MENU: 'PAYMENTS_DRAWER_MENU',
  REWARDS_DRAWER_MENU: 'REWARDS_DRAWER_MENU',
  REPORTS_DRAWER_MENU: 'REPORTS_DRAWER_MENU',
  FEEDBACK_DRAWER_MENU: 'FEEDBACK_DRAWER_MENU',
  SUPPORT_DRAWER_MENU: 'SUPPORT_DRAWER_MENU',
  SHOP_PROFILE_DRAWER_MENU: 'SHOP_PROFILE_DRAWER_MENU',
  SHOW_ALL: 'SHOW_ALL',
};

export const GA4_ANALYTICS_EVENTS = {
  SELECT_LINK: 'select_link',
  SELECT_ITEM: 'select_item',
  SELECT_ENTITY: 'select_entity',
  SELECT_PROMOTION: 'select_promotion',
  MARK_FEVOURITE: 'mark_favourite',
  UNMARK_FEVOURITE: 'unmark_favourite',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  GA4_PURCHASE: 'ga4_purchase',
  INPUT_FIELD: 'input_field',
};

export const ANALYTICS_CUSTOM_EVENTS_CATEGORIES = {
  ADD_CASES_TO_CART: 'ADD_CASES_TO_CART',
  ADD_UNITS_TO_CART: 'ADD_UNITS_TO_CART',
  REMOVE_CASES_FROM_CART: 'REMOVE_CASES_FROM_CART',
  REMOVE_UNITS_FROM_CART: 'REMOVE_UNITS_FROM_CART',
};

export const RETAILER_ROLES = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
};

export const RETAILER_PERMISSIONS = {
  ADD_USER: 'ADD_USER',
  REMOVE_USER: 'REMOVE_USER',
  UPDATE_ROLE: 'UPDATE_ROLE',
};
